<template lang="pug">
section
  div
    | The decision letter will be emailed
    | to the authorising officer’s mailbox
    | with the result of the application
    | (also periodically check junk folder):

  br

  ul
    li
      | whether your application
      | has been approved or refused
    li
      | the reasons for rejection
      | or refusal of your application

  br

  div
    b
      | Grant

  div
    | If successful your A-rated licence
    | will be valid for four years
    | from the date of decision.
    | You will be granted access
    | to the Sponsor Management System
    | via login details
    | for the nominated user.
    | The organisation will
    | then have the ability
    | to start sponsoring workers.

  br

  div
    b
      | Rejection

  div
    | An application is typically rejected
    | due to missing or incorrectly submitted
    | information or documents.
    | The application fee is refunded,
    | and you can re-apply straight away
    | after you correct your mistakes.

  br

  div
    b
      | Refusal

  div
    | Your application can be refused
    | by the Home Office
    | for a number of reasons.
    | The most common are:

  ul
    li
      | the business has not responded
      | to Home Office enquiries on time;
    li
      | failure to pass
      | the Home Office’s visit and checks;
    li
      | the business does not have
      | appropriate policy and procedure
      | in place to meet its sponsorship duties;
    li
      | the business does not pass
      | its ‘genuineness test’;
    li
      | a previously held
      | sponsorship licence being revoked.

  br

  div
    | If the application is refused,
    | there is no right of appeal
    | against this decision
    | unless you believe
    | that the refusal decision is either:
    | 1) a caseworker error;
    | or 2) supporting evidence sent
    | as part of your application
    | not being considered
    | -
    | in those cases you can send
    | an ‘Error correction request form’
    | within 14 calendar days from the date
    | of the refusal decision letter.

  br

  div
    | The application fee
    | is not refunded
    | and you can re-apply only
    | after the imposed 'cooling off' period
    | (6-12 months) has passed.
</template>

<script>
export default {
  name: "decision_notification",
};
</script>